import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const SnackBar = styled.div`
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  visibility: hidden;
  min-width: 300px;
  background-color: #000;
  color: white;
  text-align: center;
  padding: 16px;
  border-radius: 8px;
  position: fixed;
  z-index: 1000;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  transition: visibility 0s, opacity 0.5s ease-in-out;
  opacity: 0;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 12px 32px 0px rgba(35, 41, 54, 0.14);

  &.show {
    visibility: visible;
    opacity: 1;
  }
  a {
    margin-left: 8px;
    text-decoration: none;
    border-bottom: 1px solid white;
    color: white;
  }
  a:hover,
  a:visited,
  a:active,
  a:focus {
    color: white;
  }
`

const Snackbar = ({ user }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const handleCheckin = (event) => {
      setShow(true)
      setTimeout(() => {
        setShow(false)
      }, 5000)
    }

    window.addEventListener('workoutCheckin:success', handleCheckin)

    return () => {
      window.removeEventListener('workoutCheckin:success', handleCheckin)
    }
  }, [])

  if (!show) return null

  return (
    <SnackBar className={show ? 'show' : ''}>
      Your workout has been logged.
      <a href={`/users/${user.username}`}>View log</a>
    </SnackBar>
  )
}

export default Snackbar
